/**
 * Language Selector Sync - Force correct language display
 * Syncs Shopify language selector with Weglot's URL-based language
 */

(function() {
  'use strict';

  function getCurrentLanguage() {
    // Check URL path first (most reliable with Weglot)
    const path = window.location.pathname;
    if (path.includes('/ar/') || path.includes('/ar?') || path.startsWith('/ar')) {
      return 'ar';
    }

    // Check Weglot API
    if (typeof Weglot !== 'undefined' && Weglot.getCurrentLang) {
      try {
        const lang = Weglot.getCurrentLang();
        if (lang) return lang;
      } catch(e) {}
    }

    // Check HTML lang attribute
    const htmlLang = document.documentElement.lang || '';
    if (htmlLang.toLowerCase().startsWith('ar')) {
      return 'ar';
    }

    return 'en';
  }

  function updateLanguageSelectors() {
    const currentLang = getCurrentLanguage();
    console.log('[Language Sync] Current language:', currentLang);

    // Find ALL types of language selectors
    const selectors = [
      '.localization-form__select',
      'select[name="language_code"]',
      '[name="locale_code"]',
      'select[id*="language"]',
      'select[id*="Language"]',
      'select[id*="locale"]'
    ];

    selectors.forEach(function(selector) {
      document.querySelectorAll(selector).forEach(function(select) {
        const options = select.querySelectorAll('option');
        let desiredValue = null;

        options.forEach(function(option) {
          const optionValue = (option.value || '').toLowerCase();
          const optionLang = (option.getAttribute('lang') || '').toLowerCase();

          if (currentLang === 'ar' && (optionValue.includes('ar') || optionLang.includes('ar'))) {
            option.selected = true;
            desiredValue = option.value;
          } else if (currentLang === 'en' && (optionValue.includes('en') || optionLang.includes('en'))) {
            option.selected = true;
            desiredValue = option.value;
          } else {
            option.selected = false;
          }
        });

        if (desiredValue !== null && select.value !== desiredValue) {
          select.value = desiredValue;
          /* Do NOT dispatch 'change' when syncing: the localization form submits on change
             and would cause a redirect loop (refresh every second). Only update the display. */
          console.log('[Language Sync] Updated selector:', selector);
        }
      });
    });

    // Force update any text displays showing wrong language
    document.querySelectorAll('[class*="language"]').forEach(function(el) {
      if (el.textContent) {
        const text = el.textContent.toLowerCase();
        // If showing "English" or "الإنجليزية" on Arabic page, update it
        if (currentLang === 'ar' && (text.includes('english') || text.includes('إنجليزي'))) {
          // Find Arabic option text
          const select = el.closest('form') ? el.closest('form').querySelector('select[name="language_code"]') : null;
          if (select) {
            const arOption = Array.from(select.options).find(opt =>
              opt.value.toLowerCase().includes('ar') || opt.lang.toLowerCase().includes('ar')
            );
            if (arOption && el.classList.contains('localization-form__select')) {
              // This is the select itself, update its value
              select.value = arOption.value;
            }
          }
        }
      }
    });
  }

  // Initial update
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', updateLanguageSelectors);
  } else {
    updateLanguageSelectors();
  }

  // Update after short delay (for Weglot initialization)
  setTimeout(updateLanguageSelectors, 100);
  setTimeout(updateLanguageSelectors, 500);
  setTimeout(updateLanguageSelectors, 1000);
  setTimeout(updateLanguageSelectors, 2000);

  // Watch for Weglot language changes
  document.addEventListener('weglotLanguageChanged', function() {
    console.log('[Language Sync] Weglot language changed');
    setTimeout(updateLanguageSelectors, 100);
    setTimeout(updateLanguageSelectors, 500);
  });

  // Watch for DOM changes (language selectors added dynamically)
  const observer = new MutationObserver(function(mutations) {
    let hasNewSelects = false;
    mutations.forEach(function(mutation) {
      mutation.addedNodes.forEach(function(node) {
        if (node.nodeType === 1) { // Element node
          if (node.tagName === 'SELECT' || node.querySelector && node.querySelector('select[name="language_code"]')) {
            hasNewSelects = true;
          }
        }
      });
    });

    if (hasNewSelects) {
      setTimeout(updateLanguageSelectors, 50);
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

  // Update on page visibility change (coming back to tab)
  document.addEventListener('visibilitychange', function() {
    if (!document.hidden) {
      setTimeout(updateLanguageSelectors, 100);
    }
  });

  // Update on window focus
  window.addEventListener('focus', function() {
    setTimeout(updateLanguageSelectors, 100);
  });

  /**
   * Mobile drawer (and any) localization form: when Weglot is present, use Weglot.switchTo()
   * instead of submitting to Shopify. Otherwise the form POSTs to /localization,
   * Shopify redirects, but Weglot never switches the URL to /ar/... so content stays English.
   */
  document.addEventListener('submit', function(ev) {
    const form = ev.target;
    if (!form || form.nodeName !== 'FORM') return;
    const langSelect = form.querySelector('select[name="language_code"]');
    if (!langSelect || !langSelect.value) return;
    if (!form.classList.contains('localization-form') && !form.closest('.menu-drawer__localization')) return;
    if (typeof Weglot === 'undefined' || !Weglot.switchTo) return;

    ev.preventDefault();
    ev.stopPropagation();
    const code = (langSelect.value || '').trim().toLowerCase();
    if (!code) return;
    try {
      Weglot.switchTo(code);
      var drawer = form.closest('.menu-drawer') || form.closest('header-drawer');
      if (drawer) {
        var details = drawer.querySelector('details[open]') || drawer.closest('details[open]');
        if (details) details.removeAttribute('open');
      }
    } catch (e) {
      console.warn('[Language Sync] Weglot.switchTo failed, falling back to form submit', e);
      form.submit();
    }
  }, true);

  console.log('[Language Sync] Initialization complete');
})();
